import { useGetState } from "components/ReduxProvider";
import { useNetworkState } from "react-use";

export const useIsOffline = () => {
  const connectionProblem = useGetState("connectionProblem");
  const network = useNetworkState();
  return connectionProblem && !network.online;
};
